import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import editAuditDialog from '../../dialog.editAuditDialog';
import controller from './mark-audit-complete-confirm-dialog.controller';
import template from './mark-audit-complete-confirm-dialog.html';


class dialogService {
  getOptions($event, { audit, refreshAudit, canSave }) {
    return {
      controller,
      controllerAs: 'markAuditCompleteConfirmDialogVM',
      locals: {
        audit,
        refreshAudit,
        canSave
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.markAuditCompleteConfirmDialog', [
  alerts,
  amDataService,
  constants,
  editAuditDialog,
  loaderService,
  ssDialogService,
])
  .service('markAuditCompleteConfirmDialog', dialogService)
  .name;
